import {ebsApi} from 'store/ebsApi';
import type {User, UserDto} from './types';

const usersApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getUsers: build.query<User[], void, {users?: UserDto[]}>({
      query: () => {
        return {
          url: '/users',
        };
      },
      transformResponse: response => response?.users ?? [],
    }),
  }),
});

export const {useLazyGetUsersQuery, useGetUsersQuery} = usersApi;
